(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-countdown-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function init() {
    document.querySelectorAll('.wm-cd[data-end-local]').forEach(function (el) {
      if (el.dataset.cdBound) return; el.dataset.cdBound = '1';
      var parts = (el.getAttribute('data-end-local') || '').split(',');
      if (parts.length < 5) return;
      // Build the end moment in the visitor's OWN local timezone (same wall-clock time for everyone).
      var end = new Date(
        parseInt(parts[0], 10),
        parseInt(parts[1], 10) - 1,
        parseInt(parts[2], 10),
        parseInt(parts[3], 10),
        parseInt(parts[4], 10),
        0
      ).getTime();
      if (!end || isNaN(end)) return;
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          if (h) h.textContent = '00'; if (m) m.textContent = '00'; if (s) s.textContent = '00';
          clearInterval(iv);
          if (el.getAttribute('data-hide-expired') === 'true') { el.style.display = 'none'; }
          return;
        }
        var t = Math.floor(diff / 1000);
        if (h) h.textContent = pad(Math.floor(t / 3600) % 24);
        if (m) m.textContent = pad(Math.floor((t % 3600) / 60));
        if (s) s.textContent = pad(t % 60);
      }
      var iv = setInterval(tick, 1000);
      tick();
    });
  }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bestsellers-carousel-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.wm-bs').forEach(function (root) {
      if (root.dataset.bound) return; root.dataset.bound = '1';
      var car = root.querySelector('[data-carousel]');
      var fill = root.querySelector('[data-progress]');
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      if (!car) return;
      function step() { var c = car.querySelector('.wm-bs__card'); return c ? c.offsetWidth + parseInt(getComputedStyle(car).columnGap || 20, 10) : car.clientWidth; }
      function upd() {
        if (!fill) return;
        var max = car.scrollWidth - car.clientWidth;
        var p = max > 0 ? (car.scrollLeft / max) : 1;
        fill.style.width = Math.max(0.12, p) * 100 + '%';
      }
      if (prev) prev.addEventListener('click', function () { car.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { car.scrollBy({ left: step(), behavior: 'smooth' }); });
      car.addEventListener('scroll', upd, { passive: true });
      upd();
    });
  }
  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGroup(root) {
    var pills = root.querySelectorAll('.wm-faq__pill');
    var cats = root.querySelectorAll('.wm-faq__cat');
    var input = root.querySelector('.wm-faq__search-input');
    var empty = root.querySelector('.wm-faq__empty');
    var active = 'all';
    var activePill = root.querySelector('.wm-faq__pill.is-active');
    if (activePill) active = activePill.getAttribute('data-pill');
    var query = '';

    function apply() {
      var anyAtAll = false;
      cats.forEach(function (cat) {
        var byPill = (active === 'all' || active === cat.getAttribute('data-cat'));
        var anyVisible = false;
        cat.querySelectorAll('.wm-faq__item').forEach(function (item) {
          var matches = !query || (item.getAttribute('data-text') || '').indexOf(query) !== -1;
          var show = byPill && matches;
          item.hidden = !show;
          if (show) anyVisible = true;
        });
        cat.hidden = !anyVisible;
        if (anyVisible) anyAtAll = true;
      });
      if (empty) empty.hidden = anyAtAll;
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        active = pill.getAttribute('data-pill');
        pills.forEach(function (p) { p.classList.toggle('is-active', p === pill); });
        apply();
      });
    });
    if (input) {
      input.addEventListener('input', function () {
        query = (input.value || '').toLowerCase().trim();
        apply();
      });
    }
    apply();
  }
  function init() { document.querySelectorAll('.wm-faq').forEach(initGroup); }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-tabs-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initGroup(root) {
    if (root.dataset.wmFcBound) return;
    root.dataset.wmFcBound = '1';
    var tabs = root.querySelectorAll('.wm-fc__tab');
    var panels = root.querySelectorAll('.wm-fc__panel');
    function select(tab) {
      var id = tab.getAttribute('data-tab');
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-panel') === id);
      });
    }
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { select(tab); });
    });
    // Theme editor: selecting a Tab block shows its products
    document.addEventListener('shopify:block:select', function (e) {
      if (!e.detail || e.detail.sectionId !== root.dataset.sectionId) return;
      var t = root.querySelector('.wm-fc__tab[data-tab="' + e.detail.blockId + '"]');
      if (t) select(t);
    });
  }
  function init() { document.querySelectorAll('.wm-fc').forEach(initGroup); }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["final-cta"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__wmFctaScroll) return;
  window.__wmFctaScroll = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Height of a sticky/fixed header, so targets don't end up hidden underneath it
  function headerOffset() {
    var header = document.querySelector('header-component, .header-wrapper, #header-group, .shopify-section-group-header-group');
    if (!header) return 0;
    var pos = getComputedStyle(header).position;
    var sticky = pos === 'sticky' || pos === 'fixed' || header.closest('[style*="sticky"], .header--sticky');
    return sticky ? header.getBoundingClientRect().height : 0;
  }

  // Event delegation: keeps working after the theme editor re-renders the section
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-wm-fcta-scroll]');
    if (!btn) return;
    var target = btn.getAttribute('data-wm-fcta-scroll');
    var behavior = reduceMotion.matches ? 'auto' : 'smooth';

    if (target === 'top') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: behavior });
      // Move keyboard focus to the start of the page content
      var main = document.getElementById('MainContent') || document.querySelector('main');
      if (main) {
        if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
        main.focus({ preventScroll: true });
      }
      return;
    }

    var el = null;
    try { el = document.querySelector(target); } catch (err) { el = null; }
    if (!el) el = document.getElementById(target.replace(/^#/, '')); // plain ID typed without the #
    if (!el) return; // unknown target: fall back to the normal link

    e.preventDefault();
    var extra = parseFloat(btn.getAttribute('data-wm-fcta-offset')) || 0;
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - extra;
    window.scrollTo({ top: Math.max(0, top), behavior: behavior });
    if (!el.hasAttribute('tabindex') && !el.matches('a, button, input, select, textarea')) el.setAttribute('tabindex', '-1');
    el.focus({ preventScroll: true });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-cards-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.wm-ing').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var btn = root.querySelector('[data-open-ingredients]');
      var modal = root.querySelector('.wm-ing__modal');
      if (!btn || !modal) return;
      function open() { if (modal.showModal) { modal.showModal(); } else { modal.setAttribute('open', ''); } }
      function close() { if (modal.close) { modal.close(); } else { modal.removeAttribute('open'); } }
      btn.addEventListener('click', open);
      modal.querySelectorAll('[data-close]').forEach(function (c) { c.addEventListener('click', close); });
      modal.addEventListener('click', function (e) { if (e.target === modal) { close(); } });
    });
  }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-wellmeasured"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.wm-nav').forEach(function (nav) {
      if (nav.dataset.bound) return; nav.dataset.bound = '1';
      var burger = nav.querySelector('.wm-nav__burger');
      var overlay = nav.querySelector('.wm-nav__overlay');
      function close() { nav.classList.remove('is-open'); if (burger) burger.setAttribute('aria-expanded', 'false'); document.body.style.overflow = ''; }
      function toggle() { var open = nav.classList.toggle('is-open'); if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false'); document.body.style.overflow = open ? 'hidden' : ''; }
      if (burger) burger.addEventListener('click', toggle);
      if (overlay) overlay.addEventListener('click', close);
      nav.querySelectorAll('.wm-nav__drawer a').forEach(function (a) { a.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

      // Cart icon -> open Horizon's cart drawer.
      // Horizon's own cart button is: on:click="#cart-drawer/toggle" with
      // aria-controls="cart-drawer" -> the drawer is id="cart-drawer" and
      // exposes a toggle() method. Call it directly; fall back gracefully.
      var cartBtn = nav.querySelector('.wm-nav__cart');
      if (cartBtn) {
        cartBtn.addEventListener('click', function (e) {
          var drawer = document.getElementById('cart-drawer')
            || document.querySelector('cart-drawer-component, cart-drawer, [ref="cartDrawer"]');
          if (!drawer) return; // no drawer on the page -> let the link go to /cart
          e.preventDefault();
          try {
            if (typeof drawer.toggle === 'function') { drawer.toggle(); return; }
            if (typeof drawer.open === 'function') { drawer.open(); return; }
            if (typeof drawer.show === 'function') { drawer.show(); return; }
          } catch (err) { /* fall through to the event */ }
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (c) {
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: { data: { itemCount: c.item_count, source: 'wm-nav' } }
              }));
            })
            .catch(function () { window.location.href = '/cart'; });
        });
      }

      // Search icon -> open Horizon's search modal.
      // Horizon's search button is: on:click="#search-modal/showDialog"
      // -> the modal is id="search-modal" with a showDialog() method.
      var searchBtn = nav.querySelector('.wm-nav__search');
      if (searchBtn) {
        searchBtn.addEventListener('click', function (e) {
          var modal = document.getElementById('search-modal');
          if (!modal) return; // no modal -> follow link to /search
          e.preventDefault();
          try {
            if (typeof modal.showDialog === 'function') { modal.showDialog(); return; }
            if (typeof modal.show === 'function') { modal.show(); return; }
            if (typeof modal.showModal === 'function') { modal.showModal(); return; }
            if (typeof modal.open === 'function') { modal.open(); return; }
          } catch (err) { /* fall through to navigation */ }
          window.location.href = '/search';
        });
      }
    });
  }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.wm-pdp').forEach(function (root) {
      if (root.dataset.bound) return; root.dataset.bound = '1';

      // Gallery: thumbnail switching
      var slides = root.querySelectorAll('.wm-pdp__slide');
      var thumbs = root.querySelectorAll('.wm-pdp__thumb');
      function activate(i) {
        slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.index === String(i)); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.index === String(i)); });
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { activate(t.dataset.index); }); });

      // Gallery: play video in a slide
      root.querySelectorAll('.wm-pdp__play').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var slide = btn.closest('.wm-pdp__slide');
          var tpl = slide.querySelector('.wm-pdp__video-tpl');
          if (tpl) { slide.innerHTML = tpl.innerHTML; }
        });
      });

      // Variant selection
      var form = root.querySelector('.wm-pdp__form');
      var variantInput = root.querySelector('input[name="id"]');
      var variantsEl = root.querySelector('.wm-pdp__variants');
      var atc = root.querySelector('.wm-pdp__atc');
      var variants = [];
      if (variantsEl) { try { variants = JSON.parse(variantsEl.textContent); } catch (e) {} }
      var selects = root.querySelectorAll('.wm-pdp__option-select');
      function updateVariant() {
        if (!variants.length) return;
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = variants.find(function (v) {
          return (v.options || []).every(function (opt, i) { return opt === chosen[i]; });
        });
        if (match && variantInput) {
          variantInput.value = match.id;
          if (atc) {
            atc.disabled = !match.available;
            var label = atc.querySelector('span');
            if (label && !match.available) { label.textContent = 'Sold out'; }
          }
        }
      }
      selects.forEach(function (s) { s.addEventListener('change', updateVariant); });

      // Add to cart -> AJAX -> open Horizon cart drawer
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (atc) { atc.classList.add('is-loading'); }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(form)
          })
            .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
            .then(function (res) {
              if (atc) { atc.classList.remove('is-loading'); }
              if (!res.ok) { window.location.href = '/cart'; return; }
              var drawer = document.getElementById('cart-drawer');
              return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (c) {
                  document.dispatchEvent(new CustomEvent('cart:update', {
                    bubbles: true,
                    detail: { data: { itemCount: c.item_count, source: 'wm-pdp' } }
                  }));
                  if (drawer && typeof drawer.toggle === 'function' && !drawer.hasAttribute('open')) {
                    try { drawer.toggle(); } catch (err) {}
                  }
                });
            })
            .catch(function () { if (atc) { atc.classList.remove('is-loading'); } window.location.href = '/cart'; });
        });
      }
    });
  }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.wm-rev').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var btn = root.querySelector('[data-show-more]');
      if (!btn) return;
      var batch = parseInt(btn.getAttribute('data-batch'), 10) || 3;
      btn.addEventListener('click', function () {
        var hidden = root.querySelectorAll('.wm-rev__card.is-hidden');
        for (var i = 0; i < batch && i < hidden.length; i++) { hidden[i].classList.remove('is-hidden'); }
        if (root.querySelectorAll('.wm-rev__card.is-hidden').length === 0) {
          var wrap = btn.closest('.wm-rev__more');
          if (wrap) { wrap.style.display = 'none'; }
        }
      });
    });
  }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* ---------- UGC videos: keep muted autoplay running ---------- */
  function play(vid) {
    if (!vid) return;
    vid.muted = true; // required for autoplay
    var p = vid.play();
    if (p && p.catch) { p.catch(function () {}); }
  }
  function init() {
    document.querySelectorAll('.wm-ugc__video[data-has-video]').forEach(function (card) {
      if (card.dataset.bound) return;
      card.dataset.bound = '1';
      var vid = card.querySelector('video');
      if (!vid) return;
      play(vid);
      // Keep it going if the browser ever pauses it (tab refocus, etc.)
      vid.addEventListener('pause', function () {
        if (!vid.ended) { setTimeout(function () { play(vid); }, 100); }
      });
      vid.addEventListener('canplay', function () { play(vid); });
    });
  }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
  // Re-bind when the section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', init);

  /* ---------- Review carousel ---------- */
  if (customElements.get('wm-ugc-carousel')) return;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var CLONE_SETS = 2; // copies per side so the loop never runs out of cards

  class WmUgcCarousel extends HTMLElement {
    connectedCallback() {
      this._c = [];
      this._tm = {};
      this.track = this.querySelector('.wm-ugc__rtrack');
      this.prev = this.querySelector('[data-ugc-prev]');
      this.next = this.querySelector('[data-ugc-next]');
      if (!this.track) return;

      this.orig = Array.prototype.filter.call(this.track.children, function (el) {
        return el.classList.contains('wm-ugc__review');
      });
      var many = this.orig.length > 1;
      this.loop = this.hasAttribute('data-loop') && many;
      this.auto = this.hasAttribute('data-autoplay') && many && !reduceMotion.matches;
      this.interval = Math.max(2, parseFloat(this.dataset.interval) || 5) * 1000;
      this.hold = { hover: false, focus: false, touch: false, nav: false, editor: false, hidden: document.hidden, offscreen: false };

      if (this.loop) {
        this._buildClones();
        this._jumpTo(this.orig[0]);
      }

      this._on(this.prev, 'click', () => { this._nudge(); this.go(-1); });
      this._on(this.next, 'click', () => { this._nudge(); this.go(1); });
      this._on(this.track, 'scroll', () => {
        clearTimeout(this._tm.scroll);
        this._tm.scroll = setTimeout(() => this._settle(), 150);
        if (!this.loop) this._update();
      }, { passive: true });
      if ('onscrollend' in window) this._on(this.track, 'scrollend', () => this._settle());

      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(() => this._settle());
        ro.observe(this.track);
        this._c.push(() => ro.disconnect());
      } else {
        this._on(window, 'resize', () => this._settle());
      }

      this._on(document, 'shopify:block:select', (e) => this._onSelect(e, true));
      this._on(document, 'shopify:block:deselect', (e) => this._onSelect(e, false));

      if (this.auto) this._setupAutoplay();
      this._update();
    }

    disconnectedCallback() {
      (this._c || []).forEach((fn) => fn());
      this._c = [];
      Object.keys(this._tm || {}).forEach((k) => clearTimeout(this._tm[k]));
    }

    _on(t, type, fn, opts) {
      if (!t) return;
      t.addEventListener(type, fn, opts);
      this._c.push(() => t.removeEventListener(type, fn, opts));
    }
    _later(key, fn, ms) { clearTimeout(this._tm[key]); this._tm[key] = setTimeout(fn, ms); }

    _clone(el) {
      var c = el.cloneNode(true);
      Array.prototype.slice.call(c.attributes).forEach(function (a) {
        if (a.name.indexOf('data-shopify') === 0 || a.name === 'data-block-id') c.removeAttribute(a.name);
      });
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('inert', '');
      c.classList.add('is-clone');
      return c;
    }
    _buildClones() {
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      for (var i = 0; i < CLONE_SETS; i++) {
        this.orig.forEach((el) => {
          before.appendChild(this._clone(el));
          after.appendChild(this._clone(el));
        });
      }
      this.track.insertBefore(before, this.orig[0]);
      this.track.appendChild(after);
    }

    _pad() { return parseFloat(getComputedStyle(this.track).paddingLeft) || 0; }
    _step() {
      var gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      return this.orig[0].getBoundingClientRect().width + gap;
    }
    _metrics() {
      var first = this.orig[0];
      var firstAfter = this.orig[this.orig.length - 1].nextElementSibling;
      return { start: first.offsetLeft - this._pad(), setW: firstAfter ? firstAfter.offsetLeft - first.offsetLeft : 0 };
    }
    _instant(fn) {
      this.track.classList.add('is-jumping');
      fn();
      void this.track.offsetWidth;
      this.track.classList.remove('is-jumping');
    }
    _jumpTo(card) { this._instant(() => { this.track.scrollLeft = card.offsetLeft - this._pad(); }); }

    // Loop: resting inside a clone set -> jump silently to the identical spot among the originals
    _settle() {
      if (this.loop) {
        var m = this._metrics();
        if (m.setW > 0) {
          var x = this.track.scrollLeft;
          if (x < m.start - 1) this._instant(() => { this.track.scrollLeft = x + m.setW; });
          else if (x >= m.start + m.setW - 1) this._instant(() => { this.track.scrollLeft = x - m.setW; });
        }
      }
      this._update();
    }

    _update() {
      var max = this.track.scrollWidth - this.track.clientWidth;
      if (this.loop) { this.removeAttribute('data-static'); return; }
      this.toggleAttribute('data-static', max <= 1);
    }

    go(dir) {
      var t = this.track;
      var behavior = reduceMotion.matches ? 'auto' : 'smooth';
      if (this.loop) {
        this._settle();
        t.scrollBy({ left: this._step() * dir, behavior: behavior });
        return;
      }
      // No loop: wrap around at the ends
      var max = t.scrollWidth - t.clientWidth;
      if (dir > 0 && t.scrollLeft >= max - 2) t.scrollTo({ left: 0, behavior: behavior });
      else if (dir < 0 && t.scrollLeft <= 2) t.scrollTo({ left: max, behavior: behavior });
      else t.scrollBy({ left: this._step() * dir, behavior: behavior });
    }

    /* Autoplay */
    _setupAutoplay() {
      this._on(this, 'pointerenter', (e) => { if (e.pointerType === 'mouse') { this.hold.hover = true; this._schedule(); } });
      this._on(this, 'pointerleave', (e) => { if (e.pointerType === 'mouse') { this.hold.hover = false; this._schedule(); } });
      this._on(this, 'focusin', () => { this.hold.focus = true; this._schedule(); });
      this._on(this, 'focusout', (e) => { if (!this.contains(e.relatedTarget)) { this.hold.focus = false; this._schedule(); } });
      var touch = () => {
        this.hold.touch = true;
        this._schedule();
        this._later('touch', () => { this.hold.touch = false; this._schedule(); }, 3000);
      };
      this._on(this.track, 'pointerdown', touch, { passive: true });
      this._on(this.track, 'wheel', touch, { passive: true });
      this._on(this.track, 'touchmove', touch, { passive: true });
      this._on(document, 'visibilitychange', () => { this.hold.hidden = document.hidden; this._schedule(); });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver((entries) => { this.hold.offscreen = !entries[0].isIntersecting; this._schedule(); }, { threshold: 0.15 });
        io.observe(this);
        this._c.push(() => io.disconnect());
      }
      this._schedule();
    }
    _schedule() {
      if (!this.auto) return;
      clearTimeout(this._tm.auto);
      var h = this.hold;
      if (h.hover || h.focus || h.touch || h.nav || h.editor || h.hidden || h.offscreen) return;
      this._later('auto', () => { this.go(1); this._schedule(); }, this.interval);
    }
    _nudge() {
      if (!this.auto) return;
      this.hold.nav = true;
      this._schedule();
      this._later('nav', () => { this.hold.nav = false; this._schedule(); }, 600);
    }

    _onSelect(e, selected) {
      if (!e.detail || e.detail.sectionId !== this.dataset.sectionId) return;
      this.hold.editor = selected;
      this._schedule();
      if (!selected) return;
      var card = this.track.querySelector('.wm-ugc__review[data-block-id="' + e.detail.blockId + '"]');
      if (card) {
        requestAnimationFrame(() => {
          this.track.scrollTo({ left: card.offsetLeft - this._pad(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        });
      }
    }
  }

  customElements.define('wm-ugc-carousel', WmUgcCarousel);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-section"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('.wm-vid__frame[data-has-video]').forEach(function (frame) {
      if (frame.dataset.bound) return;
      frame.dataset.bound = '1';
      var btn = frame.querySelector('.wm-vid__play');
      var vid = frame.querySelector('video');
      if (!btn || !vid) return;
      btn.addEventListener('click', function () {
        vid.setAttribute('controls', '');
        frame.classList.add('is-playing');
        var p = vid.play();
        if (p && p.catch) { p.catch(function () {}); }
      });
    });
  }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();

  } catch(e) { console.error(e); }
})();
})();
